import { render, staticRenderFns } from "./add1.vue?vue&type=template&id=71f53250"
import script from "./add1.vue?vue&type=script&lang=js"
export * from "./add1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports